import React from "react";
import DocumentItems from "../components/DocumentItems";

export default function DocumentList(...props) {
    return (
        <div className="Courses">
            <div className="AppContainer">
                <h1 className="SectionTitle">Documents</h1>
                <DocumentItems />
            </div>
        </div>
    );
}
